import enums from '@/mixins/enums';

export default {
  mixins: [enums],
  computed: {
    showReturnHomeButton() {
      const { DistributionChannelEnum } = this.enums;
      const {
        lead, channel, meno, priezvisko, cislo, email,
      } = this.$route.query;

      if (lead) {
        return false;
      }

      if (this.model) {
        return !(this.model.distributionChannel === DistributionChannelEnum.VIP && lead && channel !== 'vip');
      }

      return !(lead && (meno || priezvisko || cislo || email));
    },
  },
};
